<app-hvb-header></app-hvb-header>
<hr class="mb-0">
<div class="data-protection-page">
  <div class="title">
    {{'dataProtectionPage.title' | translate}}
  </div>
  {{'dataProtectionPage.section0.text1' | translate}}<br><br>
  {{'dataProtectionPage.section0.text2' | translate}}<br><br>
  {{'dataProtectionPage.section0.text3' | translate}}<br><br>
  {{'dataProtectionPage.section0.text4' | translate}}<br><br>
  {{'dataProtectionPage.section0.text5' | translate}}<br>
  {{'dataProtectionPage.section0.text6' | translate}}<br>
  {{'dataProtectionPage.section0.text7' | translate}}<br><br><br>
  <b>{{'dataProtectionPage.section1.title' | translate}}</b><br><br>
  {{'dataProtectionPage.section1.text1' | translate}}<br><br>
  {{'dataProtectionPage.section1.name' | translate}}<br>
  {{'dataProtectionPage.section1.street' | translate}}<br>
  {{'dataProtectionPage.section1.postalCode' | translate}}<br><br>
  {{'dataProtectionPage.section1.telephone' | translate}}<br>
  {{'dataProtectionPage.section1.email' | translate}}<br><br>
  {{'dataProtectionPage.section1.text2' | translate}}<br><br>
  <b>{{'dataProtectionPage.section1.text3' | translate}}</b><br>
  <br><br><br>
  <b>{{'dataProtectionPage.section2.title' | translate}}</b><br><br>
  {{'dataProtectionPage.section2.text1' | translate}}<br>
  <ul>
    <li>{{'dataProtectionPage.section2.bulletPoint1' | translate}}<br><br></li>
    <li>{{'dataProtectionPage.section2.bulletPoint2' | translate}}<br><br></li>
    <li>{{'dataProtectionPage.section2.bulletPoint3' | translate}}<br><br></li>
    <li>{{'dataProtectionPage.section2.bulletPoint4' | translate}}<br><br></li>
    <li>{{'dataProtectionPage.section2.bulletPoint5' | translate}}<br><br></li>
  </ul>
  {{'dataProtectionPage.section2.text2' | translate}}<br><br>
  {{'dataProtectionPage.section2.text3' | translate}}<br>
  <br><br><br>
  <b>{{'dataProtectionPage.section3.title' | translate}}</b><br><br>
  {{'dataProtectionPage.section3.text1' | translate}}<br>
  <br><br><br>
  <b>{{'dataProtectionPage.section3.cookies.title' | translate}}</b><br><br>
  <b>{{'dataProtectionPage.section3.cookies.subtitle' | translate}}</b><br><br>
  {{'dataProtectionPage.section3.cookies.text1' | translate}}<br><br>
  {{'dataProtectionPage.section3.cookies.text2' | translate}}<br><br>
  {{'dataProtectionPage.section3.cookies.text3' | translate}}<br><br>
  {{'dataProtectionPage.section3.cookies.text4' | translate}}<br><br>
  {{'dataProtectionPage.section3.cookies.text5' | translate}}<br><br>
  {{'dataProtectionPage.section3.cookies.text6' | translate}}
  <br><br><br>
  <b>{{'dataProtectionPage.section3.customerAccount.title' | translate}}</b><br><br>
  {{'dataProtectionPage.section3.customerAccount.text1' | translate}}<br><br>
  {{'dataProtectionPage.section3.customerAccount.text2' | translate}}<br><br>
  {{'dataProtectionPage.section3.customerAccount.text3' | translate}}<br><br>
  {{'dataProtectionPage.section3.customerAccount.text4' | translate}}<br><br>
  {{'dataProtectionPage.section3.customerAccount.text5' | translate}}<br><br>
  {{'dataProtectionPage.section3.customerAccount.text6' | translate}}<br><br><br>
  <b>{{'dataProtectionPage.section3.contact.title' | translate}}</b><br><br>
  {{'dataProtectionPage.section3.contact.text1' | translate}}<br><br>
  {{'dataProtectionPage.section3.contact.text2' | translate}}<br><br>
  {{'dataProtectionPage.section3.contact.text3' | translate}}<br><br>
  {{'dataProtectionPage.section3.contact.text4' | translate}}<br>
</div>
<hvb-footer></hvb-footer>
